var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"nowrap",attrs:{"align":"center"}},[_c('v-switch',{staticClass:"ma-0",attrs:{"dense":"","hide-details":"","input-value":_vm.displayValue},on:{"change":_vm.eject,"input":_vm.eject}}),_c('div',{staticClass:"py-0 subtitle-2"},[(_vm.label)?_c('div',[_vm._v(_vm._s(_vm.displayText))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }